// Initialize Alpine.js

import Alpine from 'alpinejs'

// import focus from '@alpinejs/focus'
// Alpine.plugin(focus)

let matcher = matchMedia('(min-width: 992px)')
let mobileMenu = Alpine.reactive({
  value: !matcher.matches,
})
matcher.addListener(() => {
  mobileMenu.value = !matcher.matches
})

Alpine.magic('mobileMenu', () => mobileMenu.value)

import './data.transition.js'

window.Alpine = Alpine
